import type { CandidateDto } from '../candidate.dto';

import { normalizeArray } from '@/shared/lib/array';

export enum EmploymentTypeViewModel {
  FullTime = 'full_time',
  PartTime = 'part_time',
  Internship = 'internship',
  Freelance = 'freelance',
  ShortTerm = 'short_term',
  Seasonal = 'seasonal',
}

export type Preferences = {
  jobTitles: string[];
  workingHours: { min: number; max: number } | undefined;
  employmentTypes: EmploymentTypeViewModel[];
  commuteDistance: number;
  salary: { min: number; max: number; currency: string } | undefined;
  relocation: boolean | undefined;
  availability: string | undefined;
  locations: string[];
};

const isEmploymentTypeViewModel = (employmentType: string): employmentType is EmploymentTypeViewModel => {
  return Object.values(EmploymentTypeViewModel).includes(employmentType as EmploymentTypeViewModel);
};

export const toPreferences = (dto: CandidateDto): Preferences => {
  const employmentTypes: EmploymentTypeViewModel[] = [];
  let workingHours = undefined;

  if (dto._source.preferences?.workHours) {
    const { min, max } = dto._source.preferences.workHours;

    workingHours = {
      min: Number(min),
      max: Number(max),
    };
  }

  if (dto._source.preferences?.employmentType) {
    normalizeArray(dto._source.preferences.employmentType).forEach((employmentType) => {
      if (isEmploymentTypeViewModel(employmentType)) {
        employmentTypes.push(employmentType);
      }
    });
  }

  let salary = undefined;

  if (dto._source.preferences?.salaryRange) {
    const { min, max, currency } = dto._source.preferences.salaryRange;
    const minSalary = min || max || 0;
    const maxSalary = max || min || 0;

    salary = {
      min: minSalary,
      max: maxSalary,
      currency: currency ?? '',
    };
  }

  return {
    salary,
    workingHours,
    employmentTypes,
    jobTitles: dto._source.preferences?.jobTitles ?? [],
    commuteDistance: dto._source.preferences?.commuteDistance?.km ?? 0,
    relocation: undefined,
    availability: dto._source.preferences?.availability,
    locations: dto._source.preferences?.locations ?? [],
  };
};
